import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NodeInputsOutputsState } from "./nodeInputsOutputs-interface";
import {
  fetchNodeIODetailsByNodeUuid,
  fetchNodeIODetailsByUuid,
} from "./nodeInputsOutputs-async-calls";
import { ACP } from "../Process-modular/processModular-interface";
const initialState: NodeInputsOutputsState = {
  // nodeInputs: [],
  // nodeOutputs: [],
  // nodeIoInfo: [],
  nodeIoDetails: [],
};

const nodeInputsOutputsSlice = createSlice({
  name: "nodeInputsOutputs",
  initialState,
  reducers: {
    // setNodeInputs: (state, action: PayloadAction<ACP[]>) => {
    //   state.nodeInputs = action.payload;
    // },
    // setNodeOutputs: (state, action: PayloadAction<any[]>) => {
    //   state.nodeOutputs = action.payload;
    // },
    // setNodeIoInfo: (state, action: PayloadAction<any[]>) => {
    //   state.nodeIoInfo = action.payload;
    // },
    setNodeIoDetails: (state, action: PayloadAction<any[]>) => {
      state.nodeIoDetails = action.payload;
    },
  },
  extraReducers: (builder) => {
    // builder;
    // .addCase(fetchNodeIODetailsByNodeUuid.pending, (state) => {
    //   state.nodeIoDetails = [];
    // })
    // .addCase(fetchNodeIODetailsByNodeUuid.fulfilled, (state, action) => {
    //   state.nodeIoDetails = action.payload;
    // })
    // .addCase(fetchNodeIODetailsByNodeUuid.rejected, (state) => {
    //   state.nodeIoDetails = [];
    // })
    // .addCase(fetchNodeIODetailsByUuid.pending, (state) => {
    //   state.nodeIoDetails = [];
    // })
    // .addCase(fetchNodeIODetailsByUuid.fulfilled, (state, action) => {
    //   state.nodeIoDetails = [action.payload];
    // })
    // .addCase(fetchNodeIODetailsByUuid.rejected, (state) => {
    //   state.nodeIoDetails = [];
    // });
  },
});

export const {
  // setNodeInputs,
  // setNodeOutputs,
  // setNodeIoInfo,
  setNodeIoDetails,
} = nodeInputsOutputsSlice.actions;

export default nodeInputsOutputsSlice.reducer;
